import { Avatar, Box, Typography, useTheme } from '@mui/material';
import { SectionCard } from '@modules/talents/components/SectionCard';
import { SectionTitle } from '@modules/talents/components/SectionTitle';
import { Link } from 'react-router-dom';

interface BrandCardProps {
    brand: {
        _id: string;
        brandName: string;
        brandLogo?: { url?: string } | null;
    };
}

const BrandCard = ({ brand }: BrandCardProps) => {
    const theme = useTheme();
    return (
        <SectionCard>
            <SectionTitle title="Marque" />
            <Box component={Link} to={`/brands/${brand._id}`} sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mt: 1 }}>
                    <Avatar
                        src={brand.brandLogo?.url || '/default-logo.png'}
                        alt={brand.brandName}
                        sx={{ width: 40, height: 40, bgcolor: theme.palette.transparentPurple.main, borderRadius: '50%' }}
                    >
                        {brand.brandName?.[0]}
                    </Avatar>
                    <Typography variant="subtitle2" fontWeight={700} noWrap>
                        {brand.brandName}
                    </Typography>
                </Box>
        </SectionCard>
    );
};

export default BrandCard;
